import {
    COTIZADOR_SET_QUOTATION_VIEW,
    COTIZADOR_SET_QUOTATION_VIEW_BEGIN,
    COTIZADOR_SET_QUOTATION_VIEW_FAILURE,
} from './constants'
import { BFFAgent } from 'BFFAgent'

export function getQuotationView(quotationId) {
  return async (dispatch) => {

    dispatch({
        type: COTIZADOR_SET_QUOTATION_VIEW_BEGIN,
    })
    
    try {

        const newQuoteResponse = await BFFAgent.Cotizador.getQuotationById(quotationId)

        dispatch({
        type: COTIZADOR_SET_QUOTATION_VIEW,
        data: {
                newQuoteResponse
            }
        })

    } catch (err) {
        console.log('error: ', err)
        dispatch({
            type: COTIZADOR_SET_QUOTATION_VIEW_FAILURE,
        })
    }
  }
}

export function reducer(state, action) {
    switch (action.type) {
        case COTIZADOR_SET_QUOTATION_VIEW_BEGIN:
            return {
                ...state,
            }
        case COTIZADOR_SET_QUOTATION_VIEW:
            return {
                ...state,
                newQuoteResponse: action.data.newQuoteResponse,
                showQuotationViewError: false,
            }
        case COTIZADOR_SET_QUOTATION_VIEW_FAILURE:
            return {
                ...state,
                showQuotationViewError: true,
                newQuoteResponse: null,
            }
        default:
            return state;
    }
}
